import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/LegalPages.css';

const LegalNav = () => {
  return (
    <nav className="legal-nav-bar" aria-label="Trust and Legal Center Navigation">
      <div className="legal-nav-tabs">
        <NavLink 
          to="/shipping-policy" 
          className={({ isActive }) => `legal-tab ${isActive ? 'active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 16h6v-6.5l-3-3h-3v9.5z"/>
            <path d="M2 16h14V4H2v12z"/>
            <circle cx="6" cy="18" r="2"/>
            <circle cx="18" cy="18" r="2"/>
          </svg>
          Shipping &amp; Returns
        </NavLink>

        <NavLink 
          to="/terms" 
          className={({ isActive }) => `legal-tab ${isActive ? 'active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          Terms of Service
        </NavLink>

        <NavLink 
          to="/privacy" 
          className={({ isActive }) => `legal-tab ${isActive ? 'active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          Privacy Policy
        </NavLink>

        <NavLink 
          to="/disclaimers" 
          className={({ isActive }) => `legal-tab ${isActive ? 'active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Disclaimers &amp; Fan Art
        </NavLink>

        <NavLink 
          to="/accessibility" 
          className={({ isActive }) => `legal-tab ${isActive ? 'active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="4" r="2"/>
            <path d="M18 9h-4V7h-4v2H6v2h4v11h4V11h4V9z"/>
          </svg>
          Accessibility
        </NavLink>
      </div>
    </nav>
  );
};

export default LegalNav;
